import type { Theme } from "@mui/material";

// Deterministic placeholder colour for a dashboard tile header, until real
// per-dashboard images land. Same key -> same colour across renders.
export const dashboardTileColour = (key: string, theme: Theme): string => {
  const colours = [
    theme.palette.primary.main,
    theme.palette.secondary.main,
    theme.palette.success.main,
    theme.palette.error.main,
    theme.palette.warning.main,
  ] as const;
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash += key.charCodeAt(i);
  }
  return colours[hash % colours.length] ?? colours[0];
};
